import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import bloomberg from "../../assets/bloomberg-logo.jpg";

const LiveBadge = () => {
  return (
    <Box
      component={motion.div}
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="flex items-center space-x-2 px-3 py-1 rounded-full bg-red-600 text-white shadow-md cursor-pointer max-w-fit sm:px-3 sm:py-1 sm:space-x-2"
    >
      {/* Lien cliquable vers Bloomberg */}
      <a
        href="https://www.bloomberg.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center"
      >
        {/* Logo responsive */}
        <img
          src={bloomberg}
          alt="Bloomberg"
          className="h-5 w-auto sm:h-5 xs:h-4 rounded-md hover:opacity-80 transition duration-200"
        />
      </a>

      {/* Texte Live Streaming responsive */}
      <Typography
        variant="body2"
        fontWeight="bold"
        className="text-[0.7rem] sm:text-sm leading-tight"
      >
        Live Streaming
      </Typography>
    </Box>
  );
};

export default LiveBadge;
